import { DATASTRATEGY, STORAGESTRATEGY, HTTP_CONSTANTS } from './constants';
import { initialize } from './container';
const EntityManager = initialize();
//Note: Exporting interfaces we want to use
export { EntityManager, DATASTRATEGY, STORAGESTRATEGY, HTTP_CONSTANTS, };
